<template>
    <div class="enps-direction-chart">
        <div class="enps-direction-chart__header">
            <div class="enps-direction-chart__title">Оценка по подразделениям заявителей</div>
        </div>

        <div class="enps-chart-placeholder" v-if="!hasChartData" :style="{ height: chartHeight }">
            Нет оценок за период
        </div>
        <Bar
            v-else
            :chart-data="chartData"
            :chart-options="chartOptions"
            :styles="{ height: chartHeight, position: 'relative' }"
        ></Bar>

        <button
            v-if="departmentBreakdown.rest && !isExpanded"
            type="button"
            class="enps-direction-chart__expand"
            @click="isExpanded = true"
        >
            Показать остальные {{ departmentBreakdown.rest.count }}
        </button>
        <button
            v-else-if="departmentBreakdown.rest && isExpanded"
            type="button"
            class="enps-direction-chart__expand"
            @click="isExpanded = false"
        >
            Свернуть
        </button>
    </div>
</template>
<script>
import { Bar } from 'vue-chartjs/legacy';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { SERIES, ratingScaleColor } from '@/js/enpsColors';

const REST_COLOR = SERIES.rest;

// pt.2/pt.3: горизонтальный бар-чарт (indexAxis:'y' — читаемо при длинных названиях
// подразделений), топ-N по числу оценок с "Остальные N" сверху + приглушённые бары для
// подразделений с числом оценок ниже порога (departmentBreakdown.top[].isLowSample с бэкенда).
@Component({
    components: {
        Bar,
    },
})
class EnpsDepartmentChart extends Vue {
    @Prop({ type: Object, default: () => ({ top: [], rest: null }) })
    departmentBreakdown;
    @Prop({ type: String, required: true })
    period;

    isExpanded = false;

    get items() {
        if (this.isExpanded && this.departmentBreakdown.rest) {
            return [...this.departmentBreakdown.top, ...this.departmentBreakdown.rest.items];
        }

        return this.departmentBreakdown.top;
    }

    get hasChartData() {
        return this.departmentBreakdown.top.length > 0;
    }

    get chartHeight() {
        const itemCount = this.items.length + (this.departmentBreakdown.rest && !this.isExpanded ? 1 : 0);

        return `${Math.max(220, itemCount * 34 + 40)}px`;
    }

    get chartData() {
        const labels = this.items.map((row) => [row.department, `(${row.ratingsCount} оценок)`]);
        const data = this.items.map((row) => row.averageRating);
        // Цвет столбца — строго по значению (единая шкала >4 / 3-4 / <3 из enpsColors.js,
        // одна на все столбчатые графики): цветов ровно три, малая выборка цветом не кодируется
        // — число оценок и так напечатано в подписи строки.
        const colors = this.items.map((row) => ratingScaleColor(row.averageRating));

        if (this.departmentBreakdown.rest && !this.isExpanded) {
            const rest = this.departmentBreakdown.rest;
            labels.push(['Остальные', `(${rest.count} подразделений, ${rest.ratingsCount} оценок)`]);
            data.push(rest.averageRating);
            colors.push(REST_COLOR);
        }

        return {
            labels,
            datasets: [
                {
                    label: 'Средняя оценка',
                    data,
                    backgroundColor: colors,
                },
            ],
        };
    }

    get chartOptions() {
        return {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
            },
            scales: {
                x: { min: 0, max: 5 },
            },
        };
    }

    @Watch('period')
    onPeriodChange() {
        this.isExpanded = false;
    }
}

export default EnpsDepartmentChart;
</script>
